import WithGASetup from '../WithGASetup';
import Approval from './Approval';

export default WithGASetup(Approval);
